import * as React from 'react';
import { Model } from 'survey-core';
import { MuiCheckbox, MuiCheckboxModel } from './MuiCheckbox';
import { Box, Button, Paper, styled } from '@material-ui/core';

export const TYPE = 'mui-privacy-consent';

export class MuiPrivacyConsentModel extends MuiCheckboxModel {
  getType(): string {
    return TYPE;
  }
}

const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: 278,
  borderRadius: 100,
  textTransform: 'initial',
  fontWeight: theme.typography.fontWeightBold,
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(-0.75),
    marginBottom: theme.spacing(0.25),
    width: '100%',
    minWidth: 'initial',
    maxWidth: 294
  }
}));
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 12,
  borderColor: '#c3c6cf',
  backgroundColor: 'initial',
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(0.5)
  }
}));

export class MuiPrivacyConsent extends MuiCheckbox {
  protected renderElement(): JSX.Element | null {
    const { value, survey } = this.question;
    const model = survey as Model;

    return (
      <StyledPaper variant="outlined">
        {super.renderElement()}
        <Box mt={2.5} display="flex" justifyContent="center">
          <StyledButton
            tabIndex={1}
            variant="contained"
            color="primary"
            disabled={!value}
            onClick={() => model.completeLastPage()}
          >
            {model.completeText}
          </StyledButton>
        </Box>
      </StyledPaper>
    );
  }
}
